import { stringify } from 'query-string';
import config from 'config';
import { localStorageKeys } from '../constants';
import { userLogout } from 'react-admin';

type MakeApiBlobRequestArgs = {
  path: string;
  method?: string;
  body?: BodyInit | null;
  headers?: Record<string, string>;
  queryParams?: Record<string, any>;
  dispatch?: (action: any) => void;
};

export async function makeApiBlobRequest({ path, method = 'GET', body = null, headers = {}, queryParams = {}, dispatch }: MakeApiBlobRequestArgs) {
  const { apiUrl } = config;
  const token = localStorage.getItem(localStorageKeys.ACCESS_TOKEN);

  const url = `${apiUrl}/${path}${Object.keys(queryParams || {}).length ? `?${stringify(queryParams)}` : ''}`;

  const finalHeaders: Record<string, string> = {
    Accept: 'text/csv,application/octet-stream,*/*',
    ...(headers || {}),
    Authorization: `Bearer ${token}`,
  };

  // Ensure content-type for JSON bodies unless explicitly overridden
  if (body && !(finalHeaders['Content-Type'])) {
    finalHeaders['Content-Type'] = 'application/json';
  }

  const res = await fetch(url, {
    method,
    headers: finalHeaders as any,
    body,
  });

  if (res.status === 401 || res.status === 419 || res.status === 403) {
    if (typeof dispatch === 'function') {
      dispatch(userLogout());
    }
  }

  return res;
}
